import UPCOMING_REVIEW_ROLES from 'actions/coaching/UPCOMING_REVIEW_ROLES';

export default function (review, userId) {
  return review.coachUserId === userId
    ? UPCOMING_REVIEW_ROLES.COACH
    : UPCOMING_REVIEW_ROLES.PARTICIPANT;
}
